import React from 'react';
import Button from '../Button';

const InfoWindow = ({
  header,
  body,
  defaultButtonText,
  secondaryButtonText,
  defaultButtonCallback,
  secondaryButtonCallback,
  imageUrl,
  imageAlt,
}) => {
  return (
    <div className="info-window">
      <div className="modal-heading heading3">{header}</div>
      <p className="mb-10">{body}</p>
      {imageUrl && <img className="mb-4" src={imageUrl} alt={imageAlt} />}
      <Button type="default" text={defaultButtonText} onClick={defaultButtonCallback} />
      {secondaryButtonText && <Button type="secondary" text={secondaryButtonText} onClick={secondaryButtonCallback} />}
    </div>
  );
};

export default InfoWindow;
